import axios from 'axios'
import { ElMessageBox, ElMessage } from 'element-plus'
import store from '@/store'
import router from '@/router'

// create an axios instance
// console.log(process.env.VUE_APP_BASE_API, '777777777777');
const service = axios.create({
  baseURL: 'https://ztfapi.ruanzhongzi.com', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000, // request timeout
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    // console.log(config, 'config171717');
    // if (store.getters.token) {
    //   // let each request carry token
    //   // ['X-Token'] is a custom headers key
    //   // please modify it according to the actual situation
    //   config.headers['X-Token'] = getToken();
    // }
    // const isToken = (config.headers || {}).isToken === false;
    // if (getToken() && !isToken) {
    //   config.headers['token'] = getToken();
    // }
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data
    // console.log(res, '447477')
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 1) {
      // ElMessage({
      //   message: res.message || 'Error',
      //   type: 'error',
      //   duration: 5 * 1000,
      // })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014 || res.code === 4001) {
        // to re-login
        ElMessageBox.confirm(
          '登录失效，请重新登录',
          {
            confirmButtonText: '去登录',
            cancelButtonText: '取消',
            type: 'warning',
          }
        ).then(() => {
          // 清除本地用户信息和token
          localStorage.removeItem('jishiyu-userInfo');
          localStorage.removeItem('jishiyu-token');
          // removeToken(); // 调用auth.js中的removeToken函数
          
          // 重置store中的用户信息（如果有）
          if (store.dispatch('user/resetToken')) {
            store.dispatch('user/resetToken');
          }
          
          // 跳转登录页
          router.push({ path: '/login' });
        }).catch(() => {
          // 清除本地用户信息和token
          localStorage.removeItem('jishiyu-userInfo');
          localStorage.removeItem('jishiyu-token');
          // removeToken(); // 调用auth.js中的removeToken函数
          
          // 重置store中的用户信息（如果有）
          if (store.dispatch('user/resetToken')) {
            store.dispatch('user/resetToken');
          }
          
          // 跳转登录页
          router.push({ path: '/' });
        });
      }
      return Promise.reject(new Error(res.message || 'Error'));
    } else {
      return res
    }
  },
  (error) => {
    console.log('err' + error) // for debug
    ElMessage({
      message: error.message,
      type: 'error',
      duration: 5 * 1000,
    })
    return Promise.reject(error)
  }
)

export default service
